import React from 'react'
import { filePromises } from 'utils/fileUploadHelper'

export const UploadDocument = ({ editMode, fileName, fileUrl, isAdmin, onChange }) => {
  const onFileChange = e => {
    const files = [...e.target.files]
    Promise.all(filePromises(files))?.then(packageFiles => {
      const [fileObj] = packageFiles || {}
      const { file, fileFileName } = fileObj || {}
      onChange(current => {
        const newState = { ...current, ...{ fileFileName, fileName: fileFileName, file } }
        return newState
      })
    })
  }
  return (
    <>
      {!isAdmin && (
        <div className='row no-gutter'>
          <p className='text-small'>Please ensure in and out times are clearly visible</p>
        </div>
      )}
      <div className='row no-gutter'>
        <div className='col-md-12'>
          {fileName ? (
            <a href={fileUrl} target='_blank' rel='noopener noreferrer'>
              {fileName}
            </a>
          ) : (
            <span>{fileName}</span>
          )}
        </div>
      </div>
      {!editMode && (
        <div className='row no-gutter mb5'>
          <div className='col-md-12'>
            <button
              className='btn-fileinput btn-text-link'
              htmlFor='file-upload'
              id='file-upload'
              data-test='upload-files'>
              <input
                type='file'
                id='uploads'
                name='uploads'
                accept='.pdf, .jpg, .jpeg, .png, .doc, .docx, .tiff, .txt'
                onChange={onFileChange}
                data-test='upload-files-button'
              />
              + {fileName ? 'Replace' : 'Add'} {isAdmin ? 'Document' : 'POD'}
            </button>
          </div>
        </div>
      )}
    </>
  )
}
